export enum SettingKey {

  USER_LAYOUT_MODE = 'USER_LAYOUT_MODE',
  USER_LAYOUT_COLOR = 'USER_LAYOUT_COLOR',
  USER_LAYOUT_SIDEBAR = 'USER_LAYOUT_SIDEBAR',
  USER_LAYOUT_DIRECTION = 'USER_LAYOUT_DIRECTION',
  USER_SIDEBAR_MINI = 'USER_SIDEBAR_MINI',
  USER_LAST_STATE = 'USER_LAST_STATE',
  USER_LAST_ORG = 'USER_LAST_ORG',
  USER_OVERVIEW_ORDER = 'USER_OVERVIEW_ORDER',
  USER_LETTER_CALC = 'USER_LETTER_CALC',
  USER_SEARCH_SETTINGS_CONTACT = 'USER_SEARCH_SETTINGS_CONTACT',
  USER_SEARCH_SETTINGS_CONTACT_RELATION = 'USER_SEARCH_SETTINGS_CONTACT_RELATION',
  USER_SEARCH_SETTINGS_CONTACT_VEHICLE = 'USER_SEARCH_SETTINGS_CONTACT_VEHICLE',
  USER_SEARCH_SETTINGS_CONTACT_VEHICLE_HISTORY = 'USER_SEARCH_SETTINGS_CONTACT_VEHICLE_HISTORY',
  USER_SEARCH_SETTINGS_CONTACT_VEHICLE_REPAIR = 'USER_SEARCH_SETTINGS_CONTACT_VEHICLE_REPAIR',
  USER_SEARCH_SETTINGS_CONTACT_VEHICLE_TIRE = 'USER_SEARCH_SETTINGS_CONTACT_VEHICLE_TIRE',
  USER_SEARCH_SETTINGS_ARTICLE = 'USER_SEARCH_SETTINGS_ARTICLE',
  USER_SEARCH_SETTINGS_CATALOG = 'USER_SEARCH_SETTINGS_CATALOG',
  USER_SEARCH_SETTINGS_INVOICE = 'USER_SEARCH_SETTINGS_INVOICE',
  USER_SEARCH_SETTINGS_RECEIPT = 'USER_SEARCH_SETTINGS_RECEIPT',
  USER_SEARCH_SETTINGS_MEDIA = 'USER_SEARCH_SETTINGS_MEDIA',
  USER_SEARCH_SETTINGS_ORG_USER = 'USER_SEARCH_SETTINGS_ORG_USER',
  USER_SEARCH_SETTINGS_ORG_GROUP = 'USER_SEARCH_SETTINGS_ORG_GROUP',
  USER_SEARCH_SETTINGS_TEXT_TEMPLATE = 'USER_SEARCH_SETTINGS_TEXT_TEMPLATE',
  USER_SEARCH_SETTINGS_ORG_WALLET_TRANSACTION = 'USER_SEARCH_SETTINGS_ORG_WALLET_TRANSACTION',
  USER_SEARCH_SETTINGS_CORRESPONDENCE = 'USER_SEARCH_SETTINGS_CORRESPONDENCE',
  USER_SEARCH_SETTINGS_COMMENT = 'USER_SEARCH_SETTINGS_COMMENT',
  USER_SEARCH_SETTINGS_SUPPORT_TICKET = 'USER_SEARCH_SETTINGS_SUPPORT_TICKET',
  USER_SEARCH_SETTINGS_REGISTRY_OFFICE = 'USER_SEARCH_SETTINGS_REGISTRY_OFFICE',
  USER_SEARCH_SETTINGS_DEATH = 'USER_SEARCH_SETTINGS_DEATH',
  USER_SEARCH_SETTINGS_GOODS_GROUP = 'USER_SEARCH_SETTINGS_GOODS_GROUP',
  USER_SEARCH_SETTINGS_SHEET = 'USER_SEARCH_SETTINGS_SHEET',
  USER_RECEIPT_MEDIA_REVERSE = 'USER_RECEIPT_MEDIA_REVERSE',
  USER_TRACKING_ENABLED = 'USER_TRACKING_ENABLED',
  ORG_INVOICE_TYPE = 'ORG_INVOICE_TYPE',
  ORG_INVOICE_UNIT = 'ORG_INVOICE_UNIT',
  ORG_INVOICE_PAYMENT_TERM_DAYS = 'ORG_INVOICE_PAYMENT_TERM_DAYS',
  ORG_INVOICE_ESTIMATE_VALID_DAYS = 'ORG_INVOICE_ESTIMATE_VALID_DAYS',
  ORG_INVOICE_VAT_RATE = 'ORG_INVOICE_VAT_RATE',
  ORG_INVOICE_CURRENCY = 'ORG_INVOICE_CURRENCY',
  ORG_INVOICE_FRACTIONAL_DIGITS = 'ORG_INVOICE_FRACTIONAL_DIGITS',
  ORG_INVOICE_LOGO_EACH_PAGE = 'ORG_INVOICE_LOGO_EACH_PAGE',
  ORG_INVOICE_DUPLEX_PRINT = 'ORG_INVOICE_DUPLEX_PRINT',
  ORG_INVOICE_DUPLEX_PRINT_MSG = 'ORG_INVOICE_DUPLEX_PRINT_MSG',
  ORG_INVOICE_HEADER_MSG = 'ORG_INVOICE_HEADER_MSG',
  ORG_INVOICE_INVOICE_SUMMARY_MSG = 'ORG_INVOICE_INVOICE_SUMMARY_MSG',
  ORG_INVOICE_DELIVERY_NOTE_SUMMARY_MSG = 'ORG_INVOICE_DELIVERY_NOTE_SUMMARY_MSG',
  ORG_INVOICE_PROFORMA_INVOICE_SUMMARY_MSG = 'ORG_INVOICE_PROFORMA_INVOICE_SUMMARY_MSG',
  ORG_INVOICE_COST_ESTIMATE_SUMMARY_MSG = 'ORG_INVOICE_COST_ESTIMATE_SUMMARY_MSG',
  ORG_INVOICE_CANCELLATION_SUMMARY_MSG = 'ORG_INVOICE_CANCELLATION_SUMMARY_MSG',
  ORG_INVOICE_AUTO_INVOICEDATE_UPDATE = 'ORG_INVOICE_AUTO_INVOICEDATE_UPDATE',
  ORG_INVOICE_EDIT_ADDED_ARTICLE = 'ORG_INVOICE_EDIT_ADDED_ARTICLE',
  ORG_INVOICE_HIGHLIGHT = 'ORG_INVOICE_HIGHLIGHT',
  ORG_INVOICE_CONTACT_NUMBER_PRINT = 'ORG_INVOICE_CONTACT_NUMBER_PRINT',
  ORG_CEO_NAME = 'ORG_CEO_NAME',
  ORG_DATEV_EXPORT_CONSULTANT_NUMBER = 'ORG_DATEV_EXPORT_CONSULTANT_NUMBER',
  ORG_DATEV_EXPORT_CLIENT_NUMBER = 'ORG_DATEV_EXPORT_CLIENT_NUMBER',
  ORG_DATEV_EXPORT_BOOKING_TEXT_CONTACT_NAME = 'ORG_DATEV_EXPORT_BOOKING_TEXT_CONTACT_NAME',
  // Contact-Vehicle / Kundenfahrzeuge
  ORG_CUSTOMER_VEHICLE_EMISSIONS_TEST_DISABLE = 'ORG_CUSTOMER_VEHICLE_EMISSIONS_TEST_DISABLE',
  ORG_CUSTOMER_VEHICLE_TECH_INSPECTION_INTERVAL = 'ORG_CUSTOMER_VEHICLE_TECH_INSPECTION_INTERVAL',
  ORG_CUSTOMER_VEHICLE_EMISSIONS_TEST_INTERVAL = 'ORG_CUSTOMER_VEHICLE_EMISSIONS_TEST_INTERVAL',
  ORG_CUSTOMER_VEHICLE_CUSTOMER_SERVICE_INTERVAL = 'ORG_CUSTOMER_VEHICLE_CUSTOMER_SERVICE_INTERVAL',
  ORG_CUSTOMER_VEHICLE_TIRE_CHANGE_INTERVAL = 'ORG_CUSTOMER_VEHICLE_TIRE_CHANGE_INTERVAL',
  // Only day and month are relevant. Year must be ignored and is normally always fixed to 2002
  ORG_CUSTOMER_VEHICLE_TIRE_CHANGE_SUMMER = 'ORG_CUSTOMER_VEHICLE_TIRE_CHANGE_SUMMER',
  // Only day and month are relevant. Year must be ignored and is normally always fixed to 2002
  ORG_CUSTOMER_VEHICLE_TIRE_CHANGE_WINTER = 'ORG_CUSTOMER_VEHICLE_TIRE_CHANGE_WINTER',
  // Contact-Vehicle / Kundenfahrzeuge: Number of days for automatic renewal
  ORG_CUSTOMER_VEHICLE_NEXT_TECH_INSPECTION_DAYS = 'ORG_CUSTOMER_VEHICLE_NEXT_TECH_INSPECTION_DAYS',
  ORG_CUSTOMER_VEHICLE_NEXT_EMISSIONS_TEST_DAYS = 'ORG_CUSTOMER_VEHICLE_NEXT_EMISSIONS_TEST_DAYS',
  ORG_CUSTOMER_VEHICLE_NEXT_CUSTOMER_SERVICE_DAYS = 'ORG_CUSTOMER_VEHICLE_NEXT_CUSTOMER_SERVICE_DAYS',
  // HSN/TSN/VSN alias KBA-Nummer üblich in DE
  ORG_CUSTOMER_VEHICLE_USE_HSN_TSN_VSN = 'ORG_CUSTOMER_VEHICLE_USE_HSN_TSN_VSN',
  // Typengenehmigung (TG) und die Stammnummer üblich in CH
  ORG_CUSTOMER_VEHICLE_USE_TG_BASE_NO = 'ORG_CUSTOMER_VEHICLE_USE_TG_BASE_NO',
  ORG_FIRST_STEPS_ADDRESS = 'ORG_FIRST_STEPS_ADDRESS',
  ORG_FIRST_STEPS_BANK_ADDRESS = 'ORG_FIRST_STEPS_BANK_ADDRESS',
  ORG_FIRST_STEPS_CONTACT = 'ORG_FIRST_STEPS_CONTACT',
  ORG_FIRST_STEPS_INVOICE_DRAFT = 'ORG_FIRST_STEPS_INVOICE_DRAFT',
  ORG_PRICE_MILEAGE_ALLOWANCE = 'ORG_PRICE_MILEAGE_ALLOWANCE',
  ORG_DEFAULT_PAYMENT_METHOD = 'ORG_DEFAULT_PAYMENT_METHOD',
  ORG_DEFAULT_PAYMENT_BANK_ADDRESS_ID = 'ORG_DEFAULT_PAYMENT_BANK_ADDRESS_ID',
  ORG_MEDIA_UPLOAD_DELETION_PROTECTION = 'ORG_MEDIA_UPLOAD_DELETION_PROTECTION',
}
